export const FETCH_ROLE_LISTS = 'FETCH_ROLE_LISTS';
export const FETCH_ROLE_LISTS_SUCCESS = 'FETCH_ROLE_LISTS_SUCCESS';
export const FETCH_ROLE_LISTS_FAILURE = 'FETCH_ROLE_LISTS_FAILURE';
